import VueGtm from '@gtm-support/vue-gtm';
import router from '@/router';

export default {
    install(Vue) {
        if (import.meta.env.VITE_GTM_KEY) {
            Vue.use(VueGtm, {
                id: import.meta.env.VITE_GTM_KEY,
                vueRouter: router,
            });
        }
    },
};
